import { PaymentScheduleTable } from "src/routes/pdfs/CommitmentOrChangeOrderPdf/components/PaymentScheduleTable";
import { usePaymentScheduleTabQuery } from "src/routes/projects/commitments/components/PaymentScheduleTab.generated";
import { queryResult } from "src/utils";

type PaymentScheduleTabProps = { commitmentId: string };

export function PaymentScheduleTab({ commitmentId }: PaymentScheduleTabProps) {
  const query = usePaymentScheduleTabQuery({ variables: { commitmentId } });
  return queryResult(query, ({ commitment: c }) => <PaymentScheduleTable commitment={c} mode="view" showStatus />);
}
